<ion-header>
  <ind-page-title [viewData]="pageTitleViewData" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
  <div class="searchbar-wrapper">
    <ion-searchbar placeholder="{{searchPlaceholder}}" disabled="true"></ion-searchbar>
    <div class="searchbar-overlay">
      <ion-button tooltip="{{'FILTERS' | translate}}" class="searchbar-overlay-button" fill="clear" (click)="onFilterClick($event)">
        <ion-icon class="searchbar-overlay-button-filter-icon contactTimelineFilterIcon" slot="icon-only" src="assets/imgs/header_filter.svg"></ion-icon>
        <span *ngIf="filterButtonBadgeCount > 0" class="searchbar-filter-badge">{{ filterButtonBadgeCount }}</span>
      </ion-button>
    </div>
  </div>
  <!--Customer Glance Card-->
  <glance-card *ngIf="contactGlanceViewData" [viewData]="contactGlanceViewData"
    (onControlClick)="onQuickGlanceControlClick($event)"> </glance-card>
</ion-header>
<ion-content>
  <ind-section-header [viewData]='eventsSectionHeader' ></ind-section-header>
  <ion-list class="event-items-list" *ngIf="viewEventItems.length > 0">
    <timeline-item *ngFor="let item of viewEventItems; trackBy: trackById" [inputData]="item"
      (clickedOnHeader)="openEventDetails($event)"></timeline-item>
    <ion-infinite-scroll (ionInfinite)="doInfinite($event)" threshold="30%">
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>
  <ion-list>
    <div class="no-data-message" *ngIf="viewEventItems.length == 0">
      {{ 'NO_EVENTS' | translate}}
    </div>
  </ion-list>
</ion-content>
<footer-toolbar *ngIf="footerService.shouldShowFooter$ | async" [footerView]="'detailView'" [selectedView]="'contacts'"></footer-toolbar>